var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorteria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Porteria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #471936;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M218.34,349.182a5.266,5.266,0,1,0,3.719-1.542A5.266,5.266,0,0,0,218.34,349.182Z",
    transform: "translate(-122.279 -196.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M442.751,393.55a5.271,5.271,0,1,0,3.719,1.547A5.272,5.272,0,0,0,442.751,393.55Z",
    transform: "translate(-251.173 -221.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M215.7,114.3h-18.92V78.25A21.56,21.56,0,0,0,179.96,57.319l-14.045-3.08a22.488,22.488,0,0,0,7.885-17.1V22.541a22.541,22.541,0,1,0-45.082,0v14.6a22.485,22.485,0,0,0,7.873,17.09L122.544,57.31A21.56,21.56,0,0,0,105.71,78.241V97.108H82.5a4.3,4.3,0,0,0-4.3,4.3V114.3H48.127V102.265h18.04a4.3,4.3,0,0,0,4.3-4.294V51.564a4.3,4.3,0,0,0-4.3-4.3H4.3a4.294,4.294,0,0,0-4.3,4.3V97.97a4.294,4.294,0,0,0,4.3,4.294h18.04V114.3H4.3A4.294,4.294,0,0,0,0,118.593V139.22a4.294,4.294,0,0,0,4.3,4.294H18.92V215.7A4.294,4.294,0,0,0,23.2,220H196.8a4.294,4.294,0,0,0,4.294-4.3V194.647a4.3,4.3,0,0,0-8.593,0v16.76H27.5V161.555h55a4.3,4.3,0,1,0,0-8.593h-55v-9.447h165v16.76a4.3,4.3,0,0,0,8.593,0v-16.76H215.7a4.294,4.294,0,0,0,4.3-4.294V118.593a4.294,4.294,0,0,0-4.3-4.294ZM137.3,34.1h5.914a39.525,39.525,0,0,0,22-6.6V37.14a13.948,13.948,0,1,1-27.9,0ZM151.25,59.682a22.554,22.554,0,0,0,3.92-.348l-3.96,8.95-3.982-8.972A22.6,22.6,0,0,0,151.25,59.682Zm0-51.088a13.97,13.97,0,0,1,12.958,8.8,30.993,30.993,0,0,1-20.992,8.127H137.3V22.541A13.966,13.966,0,0,1,151.25,8.593ZM114.29,78.241a12.905,12.905,0,0,1,10.08-12.536L139.2,62.454l8.065,18.159a4.3,4.3,0,0,0,7.854,0l8.065-18.163,14.92,3.265A12.9,12.9,0,0,1,188.192,78.25V114.3H141.8V101.407a4.3,4.3,0,0,0-4.3-4.3H114.3ZM86.79,105.7H133.2v8.6H86.8ZM8.593,55.88h53.28V93.694H48.057a12.892,12.892,0,0,0-25.648,0H8.593ZM30.936,95.04a4.3,4.3,0,1,1,8.593,0v19.3H30.936Zm180.47,39.926H8.593V122.892H211.407Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorteria);
export default __webpack_public_path__ + "static/media/Porteria.62d1dff959c73e3d389ecc3fde4616f3.svg";
export { ForwardRef as ReactComponent };